var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    "data-name": "Group 3547",
    transform: "translate(-1112 -131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2681",
    "data-name": "Rectangle 2681",
    transform: "translate(1112 131)",
    fill: "#ff4f04",
    stroke: "#ff4f04",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(1118 70.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M8.05,68.117a.408.408,0,0,0-.578,0L2.578,73.011.7,71.13a.409.409,0,0,0-.578.578l2.17,2.17a.409.409,0,0,0,.578,0L8.05,68.695A.409.409,0,0,0,8.05,68.117Z",
    transform: "translate(0 -67.998)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOrange);
export default __webpack_public_path__ + "static/media/success_orange.e75e36cd92ed0494b81575c71dd64c51.svg";
export { ForwardRef as ReactComponent };